import HomeHero from "../components/HomeHero";
import HomeDetails from "../components/HomeDetails";
import SeoHead from "../components/seo/SeoHead";
import StructuredData from "../components/seo/StructuredData";
import Waves from "../blocks/Backgrounds/Waves/Waves";
import TheQAHubAcademyImage from "../images/TheQAHubAcademy.png";
import { useTranslation } from "../i18n";
import { organizationSchema, schemaGraph, webSiteSchema } from "../utils/seoData";
import "./Home.css";

function Home() {
    const { t } = useTranslation();

    return (
        <div>
            <SeoHead
                title="TheQAHub | QA, testing y automatizacion"
                description="TheQAHub es una plataforma educativa para aprender Quality Assurance, testing y automatizacion de software."
                canonicalPath="/"
            />
            <StructuredData
                data={schemaGraph([
                    organizationSchema(TheQAHubAcademyImage),
                    webSiteSchema(),
                ])}
            />
            <HomeHero />
            {/* Sección de Waves */}
            <div className="waves-section">
                <Waves 
                    lineColor="#97b79e" 
                    backgroundColor="transparent" 
                    waveSpeedX={0.02}
                    waveSpeedY={0.005}
                    waveAmpX={25}
                    waveAmpY={10}
                    xGap={12}
                    yGap={20}
                    className="custom-waves"
                />
                <p className="waves-text">{t("home.waves")}</p>
            </div>
            <HomeDetails />
        </div>
    );
}

export default Home;
